import cx from "classnames";
import React from "react";

// A simple filter which filters on provided text
export const CheckboxFilter = (props) => {
    /*
        A checkbox can have predefined or dynamic content, but can only have a positive and a negative value.
        always falls back to true/false as value.
        Be aware that the value of the checkbox is not definitively what is set in the filter! A "unset" checkbox can have a specific value set in the filter.


        Definition examples:
        {
            Filter: CheckboxFilter,
            FilterOptions: {
                optionContextIdentifier: "trainer",         // defines the identifier for a passed along context obj
                trueValueIdentifier: "uuid",                // defines the identifier to find the value
                falseValue: "",
            },
        }

        {
            Filter: CheckboxFilter,
            FilterOptions: {
                trueValue: "1",
                falseValue: "0",
            },
        }

     */

    const trueValue =
        props?.filterOptions?.trueValue !== undefined
            ? props.filterOptions.trueValue
            : props?.filterOptions?.trueValueIdentifier && props?.filterOptions?.optionContextIdentifier
            ? props.contextData?.[props.filterOptions.optionContextIdentifier]?.[props?.filterOptions?.trueValueIdentifier]
            : true;

    const falseValue =
        props?.filterOptions?.falseValue !== undefined
            ? props.filterOptions.falseValue
            : props?.filterOptions?.falseValueIdentifier && props?.filterOptions?.optionContextIdentifier
            ? props.contextData?.[props.filterOptions.optionContextIdentifier]?.[props?.filterOptions?.falseValueIdentifier]
            : false;

    const value = props?.state === trueValue ? falseValue : props?.state === falseValue ? trueValue : falseValue;

    return (
        <div className={"checkbox-filter-container"}>
            <input
                key={props.columnIdentifier}
                className={cx("checkbox-filter", props.className)}
                type={"checkbox"}
                checked={props?.state === trueValue}
                onChange={(e) => {
                    props.setFilter(props.columnIdentifier, value);
                }}
                value={value}
            />
        </div>
    );
};
